import { render } from "./PopUp.vue?vue&type=template&id=704979a2&scoped=true&bindings={\"currentSpot\":\"props\",\"show\":\"setup\",\"showAllText\":\"setup\",\"closePopup\":\"setup\",\"contentLength\":\"setup\",\"player\":\"setup\"}"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=704979a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-704979a2"

export default script